import { Button, FileInput, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { WarrantyPhoto } from '../../Models/WarrantyPhoto';

export default function EditWarrantyPhotoModal({
  show,
  setShow,
  warrantyPhoto,
  addUpdateWarrantyPhoto,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  warrantyPhoto: WarrantyPhoto | null;
  addUpdateWarrantyPhoto: (
    part: WarrantyPhoto,
    photoFile: File | null | undefined
  ) => void;
}) {
  const [file, setFile] = useState<File | null>();
  const inputFile = useRef<HTMLInputElement>(null);

  const [formData, setFormData] = useState<WarrantyPhoto>({
    id: 0,
    warrantyId: 0,
    photoUrl: null,
    notes: null,
    dateCreated: null,
  });

  const handleSetInitialValues = () => {
    const values = warrantyPhoto
      ? {
          ...warrantyPhoto,
        }
      : {
          id: 0,
          warrantyId: 0,
          photoUrl: null,
          notes: null,
          dateCreated: null,
        };
    if (inputFile.current) {
      inputFile.current.value = '';
    }
    setFormData(values as WarrantyPhoto);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [warrantyPhoto, show]);

  function handleImageChangePhoto(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setFile(event.currentTarget.files[0]);
    } else {
      setFile(null);
    }
  }
  const handleChangeInputPhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async () => {
    if (!file && !warrantyPhoto) {
      toast.error('Unable to add item. Missing file.');
    } else {
      addUpdateWarrantyPhoto(formData, file);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size='4xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  {warrantyPhoto === null ? 'New' : 'Edit'} Photo
                </h1>
              </div>
            </div>
          </div>
          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <form>
                      <div className='flex flex-col md:flex-none md:grid md:grid-cols-[50%_50%] text-xl'>
                        <div>
                          <div className='grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='font-bold content-center'>
                                Image:
                              </div>
                            </div>
                            <div className='w-full'>
                              {warrantyPhoto && (
                                <img
                                  key={warrantyPhoto.id}
                                  src={warrantyPhoto.photoUrl ?? ''}
                                  className='h-[75px] object-contain'
                                />
                              )}
                              {!warrantyPhoto && (
                                <FileInput
                                  id='file-upload'
                                  ref={inputFile}
                                  // helperText='PNG or JPG.'
                                  onChange={handleImageChangePhoto}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className='grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='font-bold content-center'>
                                Notes:
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='notes'
                                name='notes'
                                type='text'
                                placeholder='Notes...'
                                onChange={handleChangeInputPhoto}
                                value={formData.notes ?? ''}
                                sizing='md'
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          type='button'
                          className='buttonMain'
                          onClick={() => onSubmit()}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
